module.exports = "<div aria-label=\"Loading...\" class=\"main-wrapper main-wrapper-loading d-flex align-items-center justify-content-center\">\n  <mem-loader></mem-loader>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/fetch-user-data/fetch-user-data.component.html
// module id = ./src/app/auth/fetch-user-data/fetch-user-data.component.html
// module chunks = main